import * as React from "react";
import * as ReactDOM from "react-dom/client";

import {
	createBrowserRouter,
	RouterProvider,
} from "react-router-dom";

import RootPage from "./routes/root";
import BidPage from "./routes/bid";
import ErrorPage from "./routes/error";

const router = createBrowserRouter([
	{
		path: "/",
		element: <RootPage />,
		errorElement: <ErrorPage />,
		children: [

		],
	},
	{
		path: "bid/:lead_xid",
		element: <BidPage />
	},
]);

ReactDOM.createRoot(document.getElementById("root")).render(
	<React.StrictMode>
		<RouterProvider router={router} />
	</React.StrictMode>
);
